// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"666":"56a6c470","787":"646f5c99"}[chunkId] + ".chunk.js";
};